import { ldb } from '@codesuma/baseline'

// The app font is switchable from the menu. The chosen family is written to the
// `--app-font` CSS variable on <html>, which the global `*` rule reads, so the
// change cascades everywhere. Persisted in localStorage and re-applied on boot.
export const FONTS = ['Comic Neue', 'Coming Soon', 'Open sans', 'Quicksand'] as const
export type Font = typeof FONTS[number]

const KEY = 'app-font'
const DEFAULT: Font = 'Quicksand'

const get = (): Font => {
    const saved = ldb.get(KEY)
    return (FONTS as readonly string[]).includes(saved) ? (saved as Font) : DEFAULT
}

const apply = (font: Font): void => {
    document.documentElement.style.setProperty('--app-font', `"${font}"`)
}

const set = (font: Font): void => {
    ldb.set(KEY, font)
    apply(font)
}

const init = (): void => apply(get())

export default { FONTS, get, set, init }
